import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { PgsApi } from "../../../services";

const CREDIT_CARD_CLIENT = "cc";

const getPgsClient = async () => {
  const pgs = PgsApi.init();
  return await pgs.getClient(CREDIT_CARD_CLIENT);
};

export const usePgsScriptLink = () => {
  return useQuery([QUERY_KEYS.pgsClient], getPgsClient, {
    staleTime: 5000,
    retry: false,
  });
};
